{
  "Analyze": "Analyze",
  "Assignments": "Assignments",

  "Category": "Category",
  "Clear All": "Clear All",
  "Content": "Content",
  "Completed": "Completed",
  "CompletedOn": "Completed on",
  "Completion Rate": "Completion Rate",
  "Completions": "Completions",

  "Date Completed":  "Completed",

  "Estimated time to complete the learning item": "Estimated time to complete the learning item",
  "Expired": "Expired",
  "ExpiredOn": "Expired on",

  "Learners": "Learners",
  "Learning Items": "Learning Items",
  "Learning Type": "Learning Type",
  "Year": "Year",

  "Name": "Name",
  "No": "No",
  "Not Completed": "Not Completed",
  "Number of learning items completed by learner": "Number of learning items completed by learner",
  "Number of learning items started by learner": "Number of learning items started by learner",
  "Number of team members assigned": "Number of team members assigned",
  "Number of team members started learning item": "Number of team members started learning item",
  "Number of team members that completed full assigment": "Number of team members that completed full assigment",
  "Date learning item was completed": "Date learning item was completed",
  "Estimated time to complete learning item": "Estimated time to complete learning item",
  "Progress": "Progress",

  "Required": "Required",

  "Search Assignments": "Search assignment",
  "Search Learner": "Search learner",
  "Search Learners": "Search learner",
  "Search Learning": "Search learning",
  "Standard": "Standard",
  "Strategic": "Strategic",
  "Started": "Started",
  "Status": "Status",

  "empty-state-after-processed-title": "No results found",
  "empty-state-after-processed-subtitle": "Modify your search or filter options to find what you are looking for",
  "empty-state-no-data-title": "Once the learner gets going, you’ll find data here",
  "empty-state-no-data-subtitle": "Until then, think about how you can support this learner in their learning experience",
  "empty-state-clear-filters-action": "Clear filters",
  "empty-state-no-data-found": "No data to display yet",

  "Team": "Team",
  "Time": "Time",
  "Title": "Title",
  "Total number of hours spent on learning": "Total number of hours spent on learning",
  "Total Time": "Total Time",
  "Type": "Type",

  "Yes": "Yes",

  "Joined": "Joined",
  "Last active": "Last active",
  "Average progress": "Average progress",
  "Time spent": "Time spent",
  "learnings-count": "{{count}} learnings",
  "completions": "{{completions}} <0>out of {{total}}</0>",
  "External item": "External item",

  "Reflections": "Reflections",
  "Active learners": "Active learners",
  "Weekly goal achievers": "Weekly goal achievers",
  "Total reflections": "Total reflections",
  "Total time": "Total time",
  "Week": "Week"
}
